/**
 * @generated SignedSource<<1d4025947c9ba3fb71c8b481a02fe7b3>>
 * @relayHash 45ca605be8de33095ebc20743962c43e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d3bbcba102a7657676ea841184f6b31b4f0ab5cf41e8845fb7e0cd397cca8989

import type { ConcreteRequest, Query } from 'relay-runtime';
export type ConfluenceEdition = "FREE" | "PREMIUM" | "STANDARD" | "%future added value";
export type SitePermissionType = "ANONYMOUS" | "APP" | "EXTERNAL" | "INTERNAL" | "JSD" | "%future added value";
export type RestrictionsDialogQuery$variables = {
  contentId: string;
  draftShareId?: string | null | undefined;
  editGroupStart?: number | null | undefined;
  editUserStart?: number | null | undefined;
  readGroupStart?: number | null | undefined;
  readUserStart?: number | null | undefined;
  status?: ReadonlyArray<string | null | undefined> | null | undefined;
};
export type RestrictionsDialogQuery$data = {
  readonly content: {
    readonly nodes: ReadonlyArray<{
      readonly ancestors: ReadonlyArray<{
        readonly hasViewRestrictions: boolean;
        readonly id: string | null | undefined;
        readonly links: {
          readonly webui: string | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
      readonly hasInheritedRestrictions: boolean;
      readonly hasRestrictions: boolean;
      readonly hasViewRestrictions: boolean;
      readonly id: string | null | undefined;
      readonly operations: ReadonlyArray<{
        readonly operation: string | null | undefined;
        readonly targetType: string | null | undefined;
      } | null | undefined> | null | undefined;
      readonly restrictions: {
        readonly read: {
          readonly restrictions: {
            readonly group: {
              readonly count: number | null | undefined;
              readonly nodes: ReadonlyArray<{
                readonly id: string | null | undefined;
                readonly name: string | null | undefined;
                readonly permissionType: SitePermissionType | null | undefined;
              } | null | undefined> | null | undefined;
              readonly pageInfo: {
                readonly endCursor: string | null | undefined;
                readonly hasNextPage: boolean;
              } | null | undefined;
            } | null | undefined;
            readonly userWithRestrictions: {
              readonly count: number | null | undefined;
              readonly nodes: ReadonlyArray<{
                readonly accountId: string | null | undefined;
                readonly displayName: string | null | undefined;
                readonly hasSpaceEditPermission: boolean | null | undefined;
                readonly hasSpaceViewPermission: boolean | null | undefined;
                readonly permissionType: SitePermissionType | null | undefined;
                readonly profilePicture: {
                  readonly path: string;
                } | null | undefined;
                readonly restrictingContent: {
                  readonly id: string | null | undefined;
                  readonly links: {
                    readonly base: string | null | undefined;
                    readonly webui: string | null | undefined;
                  } | null | undefined;
                } | null | undefined;
                readonly type: string | null | undefined;
              } | null | undefined> | null | undefined;
              readonly pageInfo: {
                readonly endCursor: string | null | undefined;
                readonly hasNextPage: boolean;
              } | null | undefined;
            } | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly update: {
          readonly restrictions: {
            readonly group: {
              readonly count: number | null | undefined;
              readonly nodes: ReadonlyArray<{
                readonly id: string | null | undefined;
                readonly name: string | null | undefined;
                readonly permissionType: SitePermissionType | null | undefined;
              } | null | undefined> | null | undefined;
              readonly pageInfo: {
                readonly endCursor: string | null | undefined;
                readonly hasNextPage: boolean;
              } | null | undefined;
            } | null | undefined;
            readonly userWithRestrictions: {
              readonly count: number | null | undefined;
              readonly nodes: ReadonlyArray<{
                readonly accountId: string | null | undefined;
                readonly displayName: string | null | undefined;
                readonly hasSpaceEditPermission: boolean | null | undefined;
                readonly hasSpaceViewPermission: boolean | null | undefined;
                readonly permissionType: SitePermissionType | null | undefined;
                readonly profilePicture: {
                  readonly path: string;
                } | null | undefined;
                readonly restrictingContent: {
                  readonly id: string | null | undefined;
                  readonly links: {
                    readonly base: string | null | undefined;
                    readonly webui: string | null | undefined;
                  } | null | undefined;
                } | null | undefined;
                readonly type: string | null | undefined;
              } | null | undefined> | null | undefined;
              readonly pageInfo: {
                readonly endCursor: string | null | undefined;
                readonly hasNextPage: boolean;
              } | null | undefined;
            } | null | undefined;
          } | null | undefined;
        } | null | undefined;
      } | null | undefined;
      readonly space: {
        readonly containsExternalCollaborators: boolean;
        readonly externalCollaboratorCount: number;
        readonly id: string | null | undefined;
      } | null | undefined;
      readonly status: string | null | undefined;
      readonly subType: string | null | undefined;
      readonly title: string | null | undefined;
      readonly type: string | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly tenant: {
    readonly editions: {
      readonly confluence: ConfluenceEdition;
    };
  } | null | undefined;
  readonly user: {
    readonly displayName: string | null | undefined;
    readonly id: string | null | undefined;
    readonly photos: ReadonlyArray<{
      readonly isPrimary: boolean | null | undefined;
      readonly value: string | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type RestrictionsDialogQuery = {
  response: RestrictionsDialogQuery$data;
  variables: RestrictionsDialogQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "draftShareId"
},
v2 = {
  "defaultValue": 0,
  "kind": "LocalArgument",
  "name": "editGroupStart"
},
v3 = {
  "defaultValue": 0,
  "kind": "LocalArgument",
  "name": "editUserStart"
},
v4 = {
  "defaultValue": 0,
  "kind": "LocalArgument",
  "name": "readGroupStart"
},
v5 = {
  "defaultValue": 0,
  "kind": "LocalArgument",
  "name": "readUserStart"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "status"
},
v7 = {
  "kind": "ScalarField",
  "name": "id"
},
v8 = {
  "kind": "ScalarField",
  "name": "hasViewRestrictions"
},
v9 = {
  "kind": "ScalarField",
  "name": "webui"
},
v10 = {
  "kind": "ScalarField",
  "name": "type"
},
v11 = {
  "kind": "ScalarField",
  "name": "count"
},
v12 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v13 = {
  "kind": "ScalarField",
  "name": "permissionType"
},
v14 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    },
    {
      "kind": "ScalarField",
      "name": "endCursor"
    }
  ]
},
v15 = [
  (v11/*: any*/),
  {
    "concreteType": "UserWithRestrictions",
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      (v10/*: any*/),
      (v12/*: any*/),
      {
        "kind": "ScalarField",
        "name": "accountId"
      },
      {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "path"
          }
        ]
      },
      {
        "kind": "ScalarField",
        "name": "hasSpaceViewPermission"
      },
      {
        "kind": "ScalarField",
        "name": "hasSpaceEditPermission"
      },
      (v13/*: any*/),
      {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "restrictingContent",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          {
            "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
            "kind": "LinkedField",
            "name": "links",
            "plural": false,
            "selections": [
              (v9/*: any*/),
              {
                "kind": "ScalarField",
                "name": "base"
              }
            ]
          }
        ]
      }
    ]
  },
  (v14/*: any*/)
],
v16 = [
  (v11/*: any*/),
  {
    "concreteType": "Group",
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      (v7/*: any*/),
      {
        "kind": "ScalarField",
        "name": "name"
      },
      (v13/*: any*/)
    ]
  },
  (v14/*: any*/)
],
v17 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "draftShareId",
        "variableName": "draftShareId"
      },
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      },
      {
        "kind": "Variable",
        "name": "status",
        "variableName": "status"
      }
    ],
    "concreteType": "PaginatedContentListWithChild",
    "kind": "LinkedField",
    "name": "content",
    "plural": false,
    "selections": [
      {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          (v7/*: any*/),
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "ancestors",
            "plural": true,
            "selections": [
              (v7/*: any*/),
              (v8/*: any*/),
              {
                "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": [
                  (v9/*: any*/)
                ]
              }
            ]
          },
          {
            "kind": "ScalarField",
            "name": "hasInheritedRestrictions"
          },
          {
            "kind": "ScalarField",
            "name": "hasRestrictions"
          },
          (v8/*: any*/),
          {
            "kind": "ScalarField",
            "name": "title"
          },
          (v10/*: any*/),
          {
            "kind": "ScalarField",
            "name": "status"
          },
          {
            "kind": "ScalarField",
            "name": "subType"
          },
          {
            "concreteType": "OperationCheckResult",
            "kind": "LinkedField",
            "name": "operations",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "operation"
              },
              {
                "kind": "ScalarField",
                "name": "targetType"
              }
            ]
          },
          {
            "concreteType": "ContentRestrictions",
            "kind": "LinkedField",
            "name": "restrictions",
            "plural": false,
            "selections": [
              {
                "concreteType": "ContentRestriction",
                "kind": "LinkedField",
                "name": "read",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "SubjectsByType",
                    "kind": "LinkedField",
                    "name": "restrictions",
                    "plural": false,
                    "selections": [
                      {
                        "args": [
                          {
                            "kind": "Variable",
                            "name": "start",
                            "variableName": "readUserStart"
                          }
                        ],
                        "concreteType": "PaginatedUserWithRestrictions",
                        "kind": "LinkedField",
                        "name": "userWithRestrictions",
                        "plural": false,
                        "selections": (v15/*: any*/)
                      },
                      {
                        "args": [
                          {
                            "kind": "Variable",
                            "name": "start",
                            "variableName": "readGroupStart"
                          }
                        ],
                        "concreteType": "PaginatedGroupList",
                        "kind": "LinkedField",
                        "name": "group",
                        "plural": false,
                        "selections": (v16/*: any*/)
                      }
                    ]
                  }
                ]
              },
              {
                "concreteType": "ContentRestriction",
                "kind": "LinkedField",
                "name": "update",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "SubjectsByType",
                    "kind": "LinkedField",
                    "name": "restrictions",
                    "plural": false,
                    "selections": [
                      {
                        "args": [
                          {
                            "kind": "Variable",
                            "name": "start",
                            "variableName": "editUserStart"
                          }
                        ],
                        "concreteType": "PaginatedUserWithRestrictions",
                        "kind": "LinkedField",
                        "name": "userWithRestrictions",
                        "plural": false,
                        "selections": (v15/*: any*/)
                      },
                      {
                        "args": [
                          {
                            "kind": "Variable",
                            "name": "start",
                            "variableName": "editGroupStart"
                          }
                        ],
                        "concreteType": "PaginatedGroupList",
                        "kind": "LinkedField",
                        "name": "group",
                        "plural": false,
                        "selections": (v16/*: any*/)
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              {
                "kind": "ScalarField",
                "name": "containsExternalCollaborators"
              },
              {
                "kind": "ScalarField",
                "name": "externalCollaboratorCount"
              }
            ]
          }
        ]
      }
    ]
  },
  {
    "alias": "user",
    "args": [
      {
        "kind": "Literal",
        "name": "current",
        "value": true
      }
    ],
    "concreteType": "AtlassianUser",
    "kind": "LinkedField",
    "name": "confluence_atlassianUser",
    "plural": false,
    "selections": [
      (v7/*: any*/),
      (v12/*: any*/),
      {
        "concreteType": "AtlassianUserPhoto",
        "kind": "LinkedField",
        "name": "photos",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "value"
          },
          {
            "kind": "ScalarField",
            "name": "isPrimary"
          }
        ]
      }
    ],
    "storageKey": "confluence_atlassianUser(current:true)"
  },
  {
    "alias": "tenant",
    "concreteType": "ConfluenceTenantContext",
    "kind": "LinkedField",
    "name": "confluence_tenantContext",
    "plural": false,
    "selections": [
      {
        "concreteType": "Editions",
        "kind": "LinkedField",
        "name": "editions",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "confluence"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "name": "RestrictionsDialogQuery",
    "selections": (v17/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v6/*: any*/),
      (v1/*: any*/),
      (v5/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "RestrictionsDialogQuery",
    "selections": (v17/*: any*/)
  },
  "params": {
    "cacheID": "45ca605be8de33095ebc20743962c43e",
    "id": "d3bbcba102a7657676ea841184f6b31b4f0ab5cf41e8845fb7e0cd397cca8989",
    "metadata": {},
    "name": "RestrictionsDialogQuery",
    "operationKind": "query",
    "text": "query RestrictionsDialogQuery($contentId:ID!,$status:[String],$draftShareId:String,$readUserStart:Int=0,$readGroupStart:Int=0,$editUserStart:Int=0,$editGroupStart:Int=0){content(id:$contentId,status:$status,draftShareId:$draftShareId){nodes{id,ancestors{id,hasViewRestrictions,links{webui}},hasInheritedRestrictions,hasRestrictions,hasViewRestrictions,title,type,status,subType,operations{operation,targetType},restrictions{read{restrictions{userWithRestrictions(start:$readUserStart){count,nodes{type,displayName,accountId,profilePicture{path},hasSpaceViewPermission,hasSpaceEditPermission,permissionType,restrictingContent{id,links{webui,base}}},pageInfo{hasNextPage,endCursor}},group(start:$readGroupStart){count,nodes{id,name,permissionType},pageInfo{hasNextPage,endCursor}}}},update{restrictions{userWithRestrictions(start:$editUserStart){count,nodes{type,displayName,accountId,profilePicture{path},hasSpaceViewPermission,hasSpaceEditPermission,permissionType,restrictingContent{id,links{webui,base}}},pageInfo{hasNextPage,endCursor}},group(start:$editGroupStart){count,nodes{id,name,permissionType},pageInfo{hasNextPage,endCursor}}}}},space{id,containsExternalCollaborators,externalCollaboratorCount}}},user:confluence_atlassianUser(current:true){id,displayName,photos{value,isPrimary}},tenant:confluence_tenantContext{editions{confluence}}}"
  }
};
})();

(node as any).hash = "3386190526287a72d54803b61082eb40";

export default node;
